import { createRoutine } from 'redux-saga-routines';

const SEND_SHOW_PHONE = 'SEND_SHOW_PHONE';
export const sendShowPhoneAction = createRoutine(SEND_SHOW_PHONE);
